Ext.define('SA.model.LocationsObserverFactory', {
    createObserver({project, view}) {
        var observable = new Ext.util.Observable(),
            coalescingTask = SA.CoalescingMicroTask.create(() => observable.fireEvent('change:location')),
            queueTask = () => coalescingTask.queue(),
            maybeQueueTask = location => Ext.Array.from(location)
                .map(location => SA.data.LocationsCache.toLocationSeries(location))
                .filter(locationSeries => project.containsLocation(locationSeries))
                .forEach(queueTask);

        observable.mon(view, 'change:location', queueTask);
        observable.mon(project, 'change:location', queueTask);
        observable.mon(SA.data.LocationsCache, 'change:alias', maybeQueueTask);
        observable.mon(SA.data.CustomLocations, 'update:locationItem', maybeQueueTask);
        observable.mon(SA.data.FavoriteLocations, 'toggle', maybeQueueTask);

        return observable;
    }
});